var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTrade({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f3f5",
    d: "M15 15.543a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f3f5",
    d: "M22 8.543c0 3.26-2.4 5.95-5.52 6.42v-.06c-.31-3.88-3.46-7.03-7.37-7.34h-.03a6.495 6.495 0 0 1 6.42-5.52 6.5 6.5 0 0 1 6.5 6.5m-16.41-6.5H3c-.55 0-1 .45-1 1v2.59c0 .89 1.08 1.34 1.71.71l2.59-2.59c.62-.63.18-1.71-.71-1.71m12.82 20H21c.55 0 1-.45 1-1v-2.59c0-.89-1.08-1.34-1.71-.71l-2.59 2.59c-.62.63-.18 1.71.71 1.71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTrade);
export default __webpack_public_path__ + "static/media/white-trade.fd866efc3ab94de0511877f613bd0402.svg";
export { ForwardRef as ReactComponent };